module.exports = __webpack_public_path__ + "static/img/case8.a525a27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case8.jpg
// module id = YyX+
// module chunks = 0